import {
    FETCH_INVOICES,
    FETCH_INVOICES_FAILURE,
    FETCH_INVOICES_SUCCESS,
    SORT_DESC,
} from 'store/actions/types';
import utils from 'helpers/utils';

export const fetchInvoices = (payload = {}) => {
    let params = {
        onError: payload.onError || null,
        onSuccess: payload.onSuccess || null,
        size: payload.size ? payload.size : 24,
        sort_by: payload.field ? payload.field : 'id',
        sort_direction: payload.order ? payload.order.toLowerCase() : SORT_DESC,
    };

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    if (!utils.isEmpty(payload.filter)) {
        const filters = utils.buildFilterObject(payload.filter);

        params = Object.assign({}, params, filters);
    }

    if (payload.id) {
        params.id = [
            payload.id,
        ];
    }

    return {
        type: FETCH_INVOICES,
        payload: params,
    };
};

export const fetchInvoicesFailure = (error) => {
    return {
        type: FETCH_INVOICES_FAILURE,
        error: error,
    };
};

export const fetchInvoicesSuccess = (response) => {
    return {
        type: FETCH_INVOICES_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/invoices/fetchInvoices.js